import React, { useEffect, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";
import { CropDinSharp } from "@material-ui/icons";
import { request } from "../../../../api/Service";
import { store } from "../../../../redux-store/store";
import { toast } from "react-toastify";
const returnables = () => [
  { id: "true", title: "true" },
  { id: "false", title: "False" },
];

const initialFValues = {
  id: 0,
  categoryId: "",
  productName: "",
  unit: "",
  productDescription: "",
  sku: "",
  returnable: "",
  imageId: "",
};

var fileRecord = null;
var state = {
  currentFile: undefined,
  previewImage: undefined,
  progress: 0,
  message: "",
  isError: false,
  imageInfos: [],
};

export default function ProductForm(props) {
  const { addOrEdit, recordForEdit, categories } = props;
  const [file, setFile] = useState(null);
  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("productName" in fieldValues)
      temp.productName = fieldValues.productName
        ? ""
        : "This field is required.";
    if ("unit" in fieldValues)
      temp.unit = fieldValues.unit ? "" : "This unit is required.";
    if ("sku" in fieldValues)
      temp.sku = fieldValues.sku ? "" : "This sku is required.";
    if ("productDescription" in fieldValues)
      temp.productDescription = fieldValues.productDescription
        ? ""
        : "This productDescription is required.";
    if ("categoryId" in fieldValues)
      temp.categoryId =
        fieldValues.categoryId !== "" ? "" : "Select a Category";
    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const selectFile = (event) => {
    console.log("Image File:", event.target.files[0]);
    setFile(event.target.files[0]);
  };
  var get_product = (sku) =>
    request("get", {}, `api/Admin/get-product/${sku}`).then((data) => {
      if (data.companyId > 0) {
        toast.success("Product does Exist");
      }
    });
  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate, get_product);
  console.log(values);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var data = { ...values, formFile: file };
      console.log(data);
      addOrEdit(data, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            name="productName"
            label="Product Name"
            value={values.productName || ""}
            onChange={handleInputChange}
            error={errors.productName}
          />
          <Controls.Input
            label="Product Description"
            name="productDescription"
            value={values.productDescription || ""}
            onChange={handleInputChange}
            error={errors.productDescription}
          />
          <Controls.Input
            label="Unit"
            name="unit"
            value={values.unit || ""}
            onChange={handleInputChange}
            error={errors.unit}
          />

          {/* <img src={values.imageId} /> */}
          {values.imageId.length > 1 && (
            <div>
              <h3 className="font-semibold">Product Image</h3>
              {values.imageId && <img src={values.imageId} />}
              {/* <p>Image Url:{file}</p> */}
            </div>
          )}
        </Grid>
        <Grid item xs={6}>
          <Controls.Select
            name="categoryId"
            label="Categories"
            value={values.categoryId || ""}
            onChange={handleInputChange}
            options={categories}
            error={errors.categoryId}
          />
          <label style={{ marginLeft: "10px" }} htmlFor="btn-upload">
            <input
              id="btn-upload"
              name="btn-upload"
              style={{ display: "none" }}
              type="file"
              accept="image/*"
              onChange={selectFile}
            />
            <span className="flex flex-row gap-2 items-center">
              <Button
                className="btn-choose"
                variant="outlined"
                component="span"
              >
                Choose Image
              </Button>
              {values.imageId.length > 1 || file !== null ? (
                <span className="text-blue-500 italic font-semibold">
                  Upload New Image
                </span>
              ) : (
                <span className="text-blue-500 italic font-semibold">
                  Upload Image
                </span>
              )}
            </span>
          </label>

          <Controls.Select
            name="returnable"
            label="Returnables"
            value={values.returnable}
            onChange={handleInputChange}
            options={returnables()}
            error={errors.returnable}
          />

          <div style={{ position: "relative" }}>
            <Controls.Input
              label="SKU"
              name="sku"
              value={values.sku || ""}
              onChange={handleInputChange}
              error={errors.sku}
            />{" "}
            <i
              style={{ position: "absolute", bottom: "20%", left: "68%" }}
              className="fas fa-barcode fa-3x"
            ></i>
          </div>

          <div>
            <Controls.Button type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
